import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CanActivate } from "@angular/router";
import { IAppStore } from "../iappstore";
import { Store } from "@ngrx/store";
import { IUser } from "../interfaces/ilogin";

@Injectable()
export class AuthGuardService implements CanActivate {
    constructor(private router: Router,
        private readonly store: Store<IAppStore>) { }

    canActivate(): boolean {
        // Allow access to login and deloittead routes without authentication
        const currentUrl = this.router.url;
        if (currentUrl === '/login' || currentUrl === '/deloittead' || currentUrl.startsWith('/deloittead') || currentUrl === '/businessfunctionselection') {
            return true;
        }
        // if user is not logged in we'll send them to the login page
        let user: IUser = null as IUser;
        this.store.select(e => e.user)
            .subscribe(e => {
                user = e;
            });

        // Check for proper authentication - user must have name or userName to be considered authenticated
        if (!user || (!user.userName && !user.name) || (user.userName === null && user.name === null) || (user.userName === '' && user.name === '')) {
            this.router.navigate(["/login"]);
            return false;
        }
        return true;
    }
}
